const EXPORT_STATUS_ALIASES = {
  waiting: 'queued',
  queued: 'queued',
  exporting: 'running',
  running: 'running',
  complete: 'completed',
  completed: 'completed',
  cancelled: 'canceled',
  canceled: 'canceled',
  failed: 'failed',
};

export const ACTIVE_EXPORT_STATUSES = ['queued', 'running'];

export const normalizeExportStatus = status => {
  const normalizedStatus = String(status || '')
    .trim()
    .toLowerCase();

  if (EXPORT_STATUS_ALIASES[normalizedStatus]) {
    return EXPORT_STATUS_ALIASES[normalizedStatus];
  }

  return normalizedStatus || null;
};

export const normalizeExport = exportItem => {
  if (!exportItem) return null;

  const payload =
    exportItem.payload && typeof exportItem.payload === 'object'
      ? exportItem.payload
      : exportItem;

  const status =
    normalizeExportStatus(payload.status) ||
    (payload.started ? 'running' : null) ||
    normalizeExportStatus(exportItem.status);

  const id = payload.id || exportItem.id;

  if (!id || !status) return null;

  return {
    id,
    admin_id: payload.admin_id ?? exportItem.admin_id ?? null,
    status,
    rows_exported:
      payload.rows_exported ??
      exportItem.rows_exported ??
      payload.rowsWritten ??
      0,
    total_rows:
      payload.total_rows ?? exportItem.total_rows ?? payload.totalRows ?? null,
    filename: payload.filename ?? exportItem.filename ?? null,
    file_url: payload.file_url ?? exportItem.file_url ?? null,
    error: payload.error ?? exportItem.error ?? null,
    created_at: payload.created_at ?? exportItem.created_at ?? null,
    started_at: payload.started_at ?? exportItem.started_at ?? null,
    finished_at: payload.finished_at ?? exportItem.finished_at ?? null,
    file_size: payload.file_size ?? exportItem.file_size ?? null,
    file_size_bytes:
      payload.file_size_bytes ??
      exportItem.file_size_bytes ??
      payload.filesize ??
      exportItem.filesize ??
      payload.size ??
      null,
  };
};

export const normalizeExports = exports =>
  (Array.isArray(exports) ? exports : []).map(normalizeExport).filter(Boolean);

export const upsertExport = (exports, nextExport) => {
  if (!nextExport || !nextExport.id) return exports;

  const currentIndex = exports.findIndex(item => item.id === nextExport.id);

  if (currentIndex === -1) {
    return [
      {
        ...nextExport,
        created_at: nextExport.created_at || Date.now(),
      },
      ...exports,
    ];
  }

  const currentExport = exports[currentIndex];
  const updatedExport = Object.entries(nextExport).reduce(
    (result, [key, value]) => ({
      ...result,
      [key]:
        value === null || value === undefined || value === ''
          ? result[key]
          : value,
    }),
    { ...currentExport }
  );

  return exports.map(item =>
    item.id === nextExport.id ? updatedExport : item
  );
};

export const isActiveExport = exportItem =>
  ACTIVE_EXPORT_STATUSES.includes(normalizeExportStatus(exportItem?.status));

export const getExportQueueStorageKey = adminId =>
  `exportQueueDismissedCompleted:${adminId || 'guest'}`;

export const ensureExportFilename = (filename, extension = 'xlsx') => {
  if (!filename) return null;

  return /\.[a-z0-9]+$/i.test(filename) ? filename : `${filename}.${extension}`;
};
